import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "./../../../ui/Breadcrumbs";
import { connect } from "react-redux";
import {
  getFullFacility,
  updateFacility
} from "../../store/actions";
import { deleteFacilities } from "../../store/delete";
import Box from "../../../ui/Box";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TopBar from "./components/TopBar";
import Departments from "./components/Departments";
import DepartmentsModal from "./components/DepartmentsModal";
import DeleteConfirmationModal from "../../../ui/DeleteConfirmationModal";
import { Typography } from "@material-ui/core";
import Tabs from "../../../ui/Tabs";
import FacilityEditInfoForm from "./components/FacilityEditInfoForm";
import Progress from "../../../ui/Progress";
import FacilityInfoDrawer from "../../components/FacilityInfoDrawer";
import Photos from "./components/Photos";
import MapComponent from "../../components/Map";
import { useMediaQuery } from 'react-responsive'

const useStyles = makeStyles(() => ({
  facilityRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  },
  root: {
    maxWidth: 774,
    minWidth: 400,
    paddingLeft: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  infoForm: {
    marginBottom: 24
  },
  caption: {
    color: '#778899',
    fontSize: 10,
    marginBottom: 16
  }
}));

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Материально-технические ресурсы",
    link: "/work/app/manage/resources/mattech"
  },
  {
    label: "Мои адреса",
    link: "/work/app/facilities"
  }
];

const tabitems = [
  {number:0, caption: "Основные сведения"},
  {number:1, caption: "Расположение"}
];

const initialState = {
  deleteModalOpen: false,
  departmentsModalOpen: false,
  editableFacilityInfo: null,
  isEdited: true,
  isEditable: false
};

const FacilityEdit = ({
  getFullFacility,
  requestFacilityDelete,
  isDeletingFacility,
  updateFacility,
  isUpdatingFacility,
  facilityFullInfo,
  match,
  history
}) => {

  const { id } = match.params;
  const classes = useStyles();
  const [state, setStateObject] = React.useState(initialState);

  const setState = (field, value) => {
    setStateObject({
      ...state,
      [field]: value
    });
  };

  const returnBack = () => history.push("/work/app/facilities");

  useEffect(() => {
    getFullFacility(id);
  }, [id]);

  useEffect(() => {
    if (facilityFullInfo) {
      setState("editableFacilityInfo", facilityFullInfo.data);
    }
  }, [facilityFullInfo]);

  const isMedium = useMediaQuery({ maxWidth: 1024 });
  const isLarge = useMediaQuery({ minWidth: 1024 });
  const isSmall = useMediaQuery({ maxWidth: 774 });

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить адрес?"
        open={state.deleteModalOpen}
        onConfirm={() => {
          requestFacilityDelete(id);
          returnBack();
        }}
        handleClose={() => setState("deleteModalOpen", false)}
      />
      <Breadcrumbs items={items} />
      {facilityFullInfo ? (
        <div className={classes.facilityRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reloadFacility={() => getFullFacility(id)}
                returnBack={returnBack}
                updateFacility={() => {
                  setState("isEdited", true);
                  updateFacility(id, state.editableFacilityInfo);
                }}
                isUpdatingFacility={isUpdatingFacility}
                openDeleteModal={() => setState("deleteModalOpen", true)}
                disabled={!state.isEdited}
                editmode={state.isEditable}
                setEditMode={() => setState("isEditable", true)}
                setViewMode={() => setState("isEditable", false)}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
              <div className={classes.root}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography className={classes.heading}>Общие сведения</Typography>
                    <FacilityEditInfoForm
                      editmode={state.isEditable}
                      facilityInfo={facilityFullInfo.data}
                      onFormChange={formState => {
                        setState("editableFacilityInfo", formState);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Departments
                      editmode={state.isEditable}
                      id={id}
                      openModal={() => setState("departmentsModalOpen", true)}
                    />
                  </Grid>
                </Grid>
                <Photos
                  editmode={state.isEditable}
                  facilityId={id}/>
              </div>
            </Box>
            <Box noMargin>
              <div className={classes.root}>
              <Typography className={classes.heading}>Расположение объекта на карте</Typography>
              <MapComponent
                center={[facilityFullInfo.data.latitude, facilityFullInfo.data.longitude]}
                style={{"min-width":"400px", "min-height":"300px"}}
                onClick={coords => {
                  setState("editableFacilityInfo", {
                    ...state.editableFacilityInfo,
                    latitude: coords[0],
                    longitude: coords[1]
                  });
                }}
              />
            </div>
            </Box>
          </Tabs>
          </div>
          {isLarge &&
          <FacilityInfoDrawer facilityId={id} open hideLink />}
          <DepartmentsModal
            open={state.departmentsModalOpen}
            handleClose={() => setState("departmentsModalOpen", false)}
          />
        </div>
      ) : (
        <Progress />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  facilityFullInfo: state.facilities.facilityFullInfo,
  isDeletingFacility: state.facilities.isDeletingFacilities,
  isUpdatingFacility: state.facilities.isUpdatingFacility
});

const mapDispatchToProps = dispatch => ({
  getFullFacility: id => dispatch(getFullFacility(id)),
  requestFacilityDelete: id => dispatch(deleteFacilities([id])),
  updateFacility: (id, data) => dispatch(updateFacility(id, data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FacilityEdit));
